import {selector} from "./selector";

const changePasswordVisibility = function (e) {
    e.preventDefault();
    _changePasswordVisibility(selector.passwordVisibility, selector.password)
}


const _changePasswordVisibility = function (iconParent, passwordInput) {
    const icon = $(iconParent).find('i')[0];
    passwordInput = $(passwordInput)[0];
    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        icon.classList.remove('fa-eye-slash');
        icon.classList.add('fa-eye');
    } else {
        passwordInput.type = 'password';
        icon.classList.remove('fa-eye');
        icon.classList.add('fa-eye-slash');
    }
}

export {changePasswordVisibility };